import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { useRef, useLayoutEffect } from 'react';
import { mergeRefs } from '@elliemae/ds-utilities/system';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var columnMeasurerTransformer = function columnMeasurerTransformer(columnSizeService) {
  return function (value, _ref) {
    var column = _ref.column,
        grid = _ref.grid;
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var registerColumn = columnSizeService.registerColumn;
    var cellRef = useRef();
    useLayoutEffect(function () {
      var columns = columnSizeService.columns,
          expandedToContentColumns = columnSizeService.expandedToContentColumns;

      var _grid$getInstance = grid.getInstance();
          _grid$getInstance.props.minColumnWidth;
          var resizedColumns = _grid$getInstance.resizedColumns;

      if (cellRef.current) {
        // FIX: merge
        // if (column.width && column.width !== 'string' && !initialUsedSpace[column.property]) {
        //   increaseUsedSpace(getColumnWidthSize(column.width, minColumnWidth, column), column.property)
        // }
        if (column.expandWidthToContent && !expandedToContentColumns[column.uuid]) {
          // measure the content and reset to flex
          var originalWidth = cellRef.current.offsetWidth;
          cellRef.current.style.flex = 'initial';
          cellRef.current.style.minWidth = 'initial';
          var calcWidth = cellRef.current.offsetWidth + 20;

          if (originalWidth + 20 <= calcWidth) {
            resizedColumns.current[column.uuid] = calcWidth;
            columns[column.uuid].minWidth = calcWidth;
          } else {
            columns[column.uuid].minWidth = originalWidth;
          }

          expandedToContentColumns[column.uuid] = true;
          cellRef.current.style.minWidth = null;
          cellRef.current.style.flex = 1;
          column.node = cellRef.current;
        }
      }
    });
    return _objectSpread(_objectSpread({}, props), {}, {
      innerRef: mergeRefs(cellRef, props.innerRef, registerColumn(column))
    });
  };
};

export { columnMeasurerTransformer };
//# sourceMappingURL=columnMeasurerTransformer.js.map
